import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { EASE } from "@/components/Reveal";

export default function Preloader() {
  const [done, setDone] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setDone(true), 2100);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[100] bg-obsidian flex flex-col items-center justify-center"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: EASE }}
        >
          <div className="overflow-hidden">
            <motion.img
              src="/images/logo-full-bronze.png"
              alt="Sai Leela Decor — A Rajmata Jijau Enterprises Firm"
              className="h-32 sm:h-44 w-auto"
              initial={{ y: "110%" }}
              animate={{ y: 0 }}
              transition={{ duration: 1, delay: 0.15, ease: EASE }}
            />
          </div>
          <motion.div
            className="h-px bg-bronze/60 mt-6"
            initial={{ width: 0 }}
            animate={{ width: 120 }}
            transition={{ duration: 1, delay: 0.5, ease: EASE }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
